export default __webpack_public_path__ + "static/media/blog-img247.f3c00ad7.jpg";